/**
 * Логика раздела «Декор»: элемент по id, проверки «это декор» и «это ковёр» для общего кода холста.
 */
import type { CatalogItem } from "../../types";
import { decorSection } from "./catalog";
import type { DecorCatalogItem } from "./types";

export const decorItemById = (id: string): DecorCatalogItem | null =>
	decorSection.items.find((item) => item.id === id) ?? null;

/** Предмет декора ли это — по членству в разделе. */
export const isDecor = (item: CatalogItem | null): boolean =>
	item !== null && decorItemById(item.id) !== null;

/** Ковёр ли это: лежит под мебелью и рисуется своим цветом, без подложки. */
export const isRug = (item: CatalogItem | null): boolean =>
	item !== null && decorItemById(item.id)?.rug !== undefined;
